<!-- Content Wrapper Start -->
<div class="fm-content-wrapper fm-lovedone-page">
  <div class="container-fluid">
    <!-- ══════════════════════════════════════════════════════════════════
              Error State
              ══════════════════════════════════════════════════════════════════ -->
    @if (hasError()) {
      <div class="row mt-4">
        <div class="col-12">
          <div class="fm-white-column text-center py-5">
            <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
            <p class="mb-3">
              We couldn't load the prompt details. Please check your connection and try again.
            </p>
            <button type="button" class="fm-common-btn" (click)="loadDetail()">Try Again</button>
          </div>
        </div>
      </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════
              Loaded State
              ══════════════════════════════════════════════════════════════════ -->
    @else if (detail()) {
      <div class="row">
        <div class="col-12">
          <div class="row align-items-center">
            <div class="col-sm">
              <!-- Back Link + Page Title -->
              <a routerLink="/app/scheduleprompt" class="fm-back-link mb-3">
                <span class="fm-back-link-icon"><i class="bi bi-arrow-left"></i></span>
                Back to Scheduled Prompts
              </a>
              <div class="fm-page-title">
                <h2 class="fm-head-24 fm-title mb-2">
                  Prompt Tracking: {{ detail()!.memberName }}
                </h2>
                <div class="d-flex flex-wrap align-items-center gap-2 mt-1">
                  <p class="mb-0 fw-medium fm-title-prompt-name">
                    {{ detail()!.promptTitle }}
                  </p>
                  <span class="fm-title-divider">|</span>
                  <p class="mb-0 fm-title-category">
                    <i class="bi bi-tag"></i>
                    {{
                      detail()!.categoryName
                        ? detail()!.categoryName
                        : 'Automate memory collection with gentle reminders'
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ══════════════════════════════════════════════════════════════════
                      Summary Stats Cards
                      ══════════════════════════════════════════════════════════════════ -->
        <div class="col-12 mt-4 mt-sm-3">
          <div class="fm-cards-group">
            <div class="row g-3">
              <!-- Total Sent -->
              <div class="col-sm-6 col-lg-4 col-xl">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ detail()!.stats.totalSent }}</h3>
                    <p class="fm-large mb-0">Total Sent</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-send.svg" class="fm-svg" alt="Total Sent" />
                  </div>
                </div>
              </div>
              <!-- Responded -->
              <div class="col-sm-6 col-lg-4 col-xl">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ detail()!.stats.responded }}</h3>
                    <p class="fm-large mb-0">Responded</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-check-lg.svg" class="fm-svg" alt="Responded" />
                  </div>
                </div>
              </div>
              <!-- Pending -->
              <div class="col-sm-6 col-lg-4 col-xl">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ detail()!.stats.pending }}</h3>
                    <p class="fm-large mb-0">Pending</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-pending.svg" class="fm-svg" alt="Pending" />
                  </div>
                </div>
              </div>

              <!-- Stories Created -->
              <div class="col-sm-6 col-lg-4 col-xl">
                <div class="fm-white-column fm-card-icon fm-metric-card">
                  <div class="fm-card-content">
                    <h3 class="fm-head-32 fm-title">{{ detail()!.stats.storiesCreated }}</h3>
                    <p class="fm-large mb-0">Stories Created</p>
                  </div>
                  <div class="fm-metric-icon">
                    <img src="images/icons/fm-book-lg.svg" class="fm-svg" alt="Stories Created" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ══════════════════════════════════════════════════════════════════
                          Prompt Configuration
                          ══════════════════════════════════════════════════════════════════ -->
          <div class="fm-border-column fm-card-st2 mt-4">
            <div class="fm-card-head">
              <h3 class="fm-head-20 fm-card-title mb-0">PROMPT CONFIGURATION</h3>
            </div>
            <div class="fm-card-body">
              <div class="row g-4">
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Frequency:</p>
                  <p class="fm-card-content fm-large">{{ detail()!.frequencyTypeName || '—' }}</p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Questions Per Prompt:</p>
                  <p class="fm-card-content fm-large">
                    {{ detail()!.questionsPerPrompt }} Questions
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Delivery Method:</p>
                  <p class="fm-card-content fm-large">
                    {{ detail()!.deliveryMethodTypeName || '—' }}
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Started On:</p>
                  <p class="fm-card-content fm-large">{{ formatDate(detail()!.startedOn) }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- ══════════════════════════════════════════════════════════════════
                          Prompt History
                          ══════════════════════════════════════════════════════════════════ -->
          <div class="fm-prompt-history-sec fm-border-column fm-card-st2 mt-4">
            <div
              class="fm-card-head d-flex justify-content-between align-items-center flex-wrap gap-3"
            >
              <h3 class="fm-head-20 fm-card-title mb-0">Prompt History</h3>
              <ul class="fm-history-filter mb-0">
                <li>
                  <button
                    class="fm-history-filter-btn"
                    type="button"
                    [class.active]="activeFilter() === 'all'"
                    (click)="setFilter('all'); $event.stopPropagation()"
                  >
                    All
                  </button>
                </li>
                <li>
                  <button
                    class="fm-history-filter-btn"
                    type="button"
                    [class.active]="activeFilter() === 'responded'"
                    (click)="setFilter('responded'); $event.stopPropagation()"
                  >
                    Responded
                  </button>
                </li>
                <li>
                  <button
                    class="fm-history-filter-btn"
                    type="button"
                    [class.active]="activeFilter() === 'waiting'"
                    (click)="setFilter('waiting'); $event.stopPropagation()"
                  >
                    Awaiting Response
                  </button>
                </li>
                <li>
                  <button
                    class="fm-history-filter-btn"
                    type="button"
                    [class.active]="activeFilter() === 'not-responded'"
                    (click)="setFilter('not-responded'); $event.stopPropagation()"
                  >
                    No Response Received
                  </button>
                </li>
              </ul>
            </div>
            <div class="fm-card-body">
              @if (filteredHistory().length === 0) {
                <div class="text-center py-4">
                  @if (activeFilter() === 'all') {
                    <p class="mb-0 fm-large">
                      No prompt history has been recorded for this member yet.
                    </p>
                  } @else if (activeFilter() === 'responded') {
                    <p class="mb-0 fm-large">This member hasn't responded to any prompts yet.</p>
                  } @else if (activeFilter() === 'waiting') {
                    <p class="mb-0 fm-large">There are no prompts currently awaiting a response.</p>
                  } @else {
                    <p class="mb-0 fm-large">No prompts without a response were found.</p>
                  }
                </div>
              } @else {
                <div class="accordion fm-accordion" id="fmPromptHistoryAccordion">
                  @for (item of filteredHistory(); track item.promptNumber; let i = $index) {
                    <div
                      class="fm-history-item"
                      [ngClass]="getHistoryItemClass(item.responseStatus)"
                      [attr.data-status]="item.responseStatus.toLowerCase()"
                    >
                      <div class="fm-timeline-icon">
                        <span class="fm-timeline-dot">
                          <i
                            class="fm-timeline-icon-i"
                            [ngClass]="['bi', getTimelineIcon(item.responseStatus)]"
                          ></i>
                        </span>
                      </div>
                      <div class="fm-history-box">
                        <div class="accordion-item fm-accordion-item">
                          <h2 class="accordion-header fm-accordion-header">
                            <button
                              class="accordion-button fm-accordion-button"
                              type="button"
                              data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#promptHistory' + i"
                              aria-expanded="true"
                              [attr.aria-controls]="'promptHistory' + i"
                            >
                              <div class="fm-history-content">
                                <div class="fm-history-top">
                                  <div>
                                    <h3 class="fm-head-20 fm-history-prompt-name">
                                      Prompt #{{ item.promptNumber }}
                                    </h3>
                                    <p class="fm-history-send-date">
                                      Sent on {{ formatDate(item.sentDate) }}
                                    </p>
                                  </div>

                                  @if (isResponded(item.responseStatus)) {
                                    <div class="fm-status-wrap">
                                      <span
                                        class="fm-status-badge"
                                        [ngClass]="getStatusBadgeClass(item.responseStatus)"
                                        [title]="detail()!.memberName + ' — ' + getStatusLabel(item.responseStatus)"
                                      >
                                        <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                                        {{ getStatusLabel(item.responseStatus) }}
                                      </span>
                                      @if (item.responseDate) {
                                        <span class="fm-response-date"
                                          >on {{ formatDate(item.responseDate) }}</span
                                        >
                                      }
                                    </div>
                                  } @else if (item.responseStatus.toLowerCase() === 'waiting') {
                                    <span
                                      class="fm-status-badge"
                                      [ngClass]="getStatusBadgeClass(item.responseStatus)"
                                      [title]="detail()!.memberName + ' — ' + getStatusLabel(item.responseStatus)"
                                    >
                                      <i class="bi bi-hourglass-split fm-badge-icon"></i>
                                      {{ getStatusLabel(item.responseStatus) }}
                                    </span>
                                  } @else {
                                    <span
                                      class="fm-status-badge"
                                      [ngClass]="getStatusBadgeClass(item.responseStatus)"
                                      [title]="detail()!.memberName + ' — ' + getStatusLabel(item.responseStatus)"
                                    >
                                      <i class="bi bi-camera-video-fill fm-badge-icon"></i>
                                      {{ getStatusLabel(item.responseStatus) }}
                                    </span>
                                  }
                                </div>
                              </div>
                            </button>
                          </h2>
                          <div [id]="'promptHistory' + i" class="accordion-collapse collapse show">
                            <div class="accordion-body fm-accordion-body">
                              <div class="fm-question-list">
                                <label class="fm-question-label">Questions Sent:</label>
                                <ol class="fm-question-items">
                                  @for (q of item.questions; track $index) {
                                    <li class="fm-question-item">{{ q }}</li>
                                  }
                                </ol>
                              </div>

                              @if (isResponded(item.responseStatus) && item.storyId) {
                                <div class="fm-prompt-footer">
                                  <a
                                    [routerLink]="['/app/stories', item.storyId]"
                                    class="fm-view-story-btn"
                                  >
                                    View Story
                                    <i class="bi bi-arrow-right"></i>
                                  </a>
                                </div>
                              } @else if (item.responseStatus.toLowerCase() === 'waiting') {
                                <!-- <div class="fm-prompt-footer">
                                  <a
                                    href="javascript:void(0)"
                                    class="fm-record-response-btn"
                                    (click)="onRecordResponse(item)"
                                  >
                                    <i class="bi bi-mic-fill"></i>
                                    Record a Response
                                  </a>
                                </div> -->
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <!-- Prompt History Section End -->
        </div>
      </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════
              No Data State
              ══════════════════════════════════════════════════════════════════ -->
    @else {
      <div class="row mt-4">
        <div class="col-12">
          <div class="fm-white-column text-center py-5">
            <h4 class="fm-head-24 fm-head-sty2">No data available</h4>
            <p class="mb-3">
              We couldn't find prompt details for this member. The prompt may have been deleted or
              you may not have access.
            </p>
            <a routerLink="/app/scheduleprompt" class="fm-common-btn">Back to Scheduled Prompts</a>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<!-- Content Wrapper End -->
